import { useEscriptOnboardingContext } from '@/context/escript/EscriptOnboardingProvider';
import { Stack, Typography } from '@montugroup/design-system';
import { TokenInputWithAgreement } from '../Token/TokenInputWithAgreement';
import { TokenLoading } from './TokenLoading';

export const SubmitToken = () => {
  const { onboardingTokenIsPending } = useEscriptOnboardingContext();

  if (onboardingTokenIsPending) {
    return <TokenLoading />;
  }

  return (
    <>
      <Stack gap={6} sx={(theme) => ({ marginBottom: theme.spacing(6) })} data-testid="pharmacist-escript-submit-token">
        <Typography variant="subtitle2" fontWeight={600}>
          Add an eScript token.
        </Typography>
        <Typography variant="body1">We will check if uMeds can supply the medication for your customer.</Typography>
      </Stack>

      <TokenInputWithAgreement />
    </>
  );
};
